import React from 'react';
import startCase from 'lodash/startCase';
import { AnimatePresence, motion } from 'framer-motion';
import useMediaQueries from '../../../hooks/useMediaQueries';
import styles from './RaceInfo.module.scss';

function RaceInfo({ show, lap, laps, drivers }) {
    const { isLgMin } = useMediaQueries();

    return (
       <AnimatePresence>
           {show && drivers.length && 
             <motion.div 
                className={styles.container}
                initial={{
                    x: isLgMin ? '-200%' : 0,
                    y: !isLgMin ? '200%' : 0
                }} 
                animate={{
                    x: '0', 
                    y: '0',
                    duration: 4
                }} 
                exit={{
                    x: isLgMin ? '-200%' : 0,
                    y: !isLgMin ? '200%' : 0
                }}>
                <h2 className={styles.lapStatus}>Lap {lap || 0}/{laps}</h2>
                <ol className={styles.driverStatus}>
                    {drivers.map( (driver, index) => (
                        <li className={styles.driver} key={driver.name} style={{ '--driver-color': driver.color }}>
                            <strong className={styles.driverName}>
                                <span className={styles.index}>{index + 1}</span>
                                <span className={styles.truncate}>
                                    {startCase(driver.name.toLowerCase())}
                                </span>
                            </strong>
                            <span className={styles.driverTime}>
                                {driver.hasStopped ? 'Out' : (
                                    driver.interval ? `+${driver.interval.toFixed(3)}` : 'Interval'
                                )}
                            </span>
                        </li>
                    ))}  
                </ol>
            </motion.div>
           }
       </AnimatePresence>
    );
}

export default RaceInfo;